import { render, staticRenderFns } from "./FrontDeskDeviceList.vue?vue&type=template&id=67edac89"
import script from "./FrontDeskDeviceList.vue?vue&type=script&lang=js"
export * from "./FrontDeskDeviceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports